import { useContext, useEffect } from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Box,
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { useModal } from 'components/Modals';
import { toastWarning } from 'utils/toast';
import { DropsContext } from 'contexts/DropsContext';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';

const TipoModal = ({ onSubmit }) => {
  const { closeModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { control, watch, setValue, handleSubmit } = useForm({
    defaultValues: {
      especie_id: null,
      natureza_operacao_id: null,
      produto_servico_id: null,
    },
  });
  const natureza = watch('natureza_operacao_id');
  const produtoServico = watch('produto_servico_id');

  const onConfirm = (data) => {
    if (data?.especie_id && data?.natureza_operacao_id) {
      onSubmit(data);
    } else {
      toastWarning('Preencha todos os campos');
    }
  };

  useEffect(() => {
    if (natureza === 11) {
      if (!produtoServico && drops?.ProdutoServico?.length) {
        setValue('produto_servico_id', drops.ProdutoServico[0].value);
      }
    } else {
      if (produtoServico) {
        setValue('produto_servico_id', null);
      }
    }
  }, [natureza, drops?.ProdutoServico]);

  return (
    <>
      <DialogTitle>Espécie do Documento</DialogTitle>
      <DialogContent>
        <FormControl>
          <Controller
            name="especie_id"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <RadioGroup
                {...field}
                onChange={(e) => field.onChange(Number(e.target.value))}
              >
                <FormControlLabel
                  value={10}
                  control={<Radio />}
                  label="Nota Fiscal"
                />
                <FormControlLabel
                  value={25}
                  control={<Radio />}
                  label="Fatura"
                />
              </RadioGroup>
            )}
          />
        </FormControl>
      </DialogContent>
      <DialogTitle>Natureza da Operação</DialogTitle>
      <DialogContent>
        <FormControl>
          <Controller
            name="natureza_operacao_id"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <RadioGroup
                {...field}
                onChange={(e) => field.onChange(Number(e.target.value))}
              >
                <FormControlLabel value={6} control={<Radio />} label="Venda" />
                <FormControlLabel
                  value={11}
                  control={<Radio />}
                  label="Serviço"
                />
              </RadioGroup>
            )}
          />
        </FormControl>
      </DialogContent>
      {Boolean(natureza === 11) && (
        <>
          <DialogTitle>Serviço</DialogTitle>
          <DialogContent>
            <Box py={0.5} />
            <Dropdown
              label="Tipo"
              control={control}
              name="produto_servico_id"
              options={drops?.ProdutoServico}
            />
          </DialogContent>
        </>
      )}
      <DialogActions>
        <Button onClick={handleSubmit(onConfirm)}>Confirmar</Button>
        <Button onClick={closeModal} color="secondary">
          Cancelar
        </Button>
      </DialogActions>
    </>
  );
};

export default TipoModal;
